module.exports = __webpack_public_path__ + "img/deepcath.68ff5e69.jpg";